module.exports = __webpack_public_path__ + "img/payment10.98ddf3c7.png";